//this function ensures that when a BAB item is removed from the cart, any other associated BAB are also removed
document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
  const smartcart = event.detail.smartcart;
  const item = event.detail.item;

  // console.log(
  //   "rebuy:smartcart.line-item-removed: smartcart",
  //   item.properties,
  //   smartcart.cart.items
  // );

  // Empty object to store the updates
  const updates = {};

  for (const cartItem of smartcart.cart.items) {
    if (
      item.properties["_timestamp"] &&
      cartItem.properties["_timestamp"] === item.properties["_timestamp"] &&
      cartItem !== item
    ) {
      const cartItemKey = cartItem.key;
      const cartItemTitle = cartItem.title;
      if (updates[cartItemKey]) {
        updates[cartItemKey]++;
      } else {
        updates[cartItemKey] = 0;
      }
    }
  }

  if (Object.keys(updates).length > 0) {
    console.log("updates", updates);
    try {
      fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          console.log("Cart updated successfully:", data);
        })
        .catch((error) => {
          console.error("Error updating cart:", error);
        });
    } catch (error) {
      console.error("Invalid JSON data:", error);
    }
  }

  //update price of bab parent to reflect contents
});

function updateRebuyBundlePrices() {
  let intervalId;
  let timeElapsed = 0;
  const maxTime = 5000; // 5 seconds in milliseconds

  intervalId = setInterval(function () {
    const lineItems = document.querySelectorAll(".rebuy-cart__flyout-item");
    let elementFound = false;

    for (const item of lineItems) {
      if (item.classList.contains("property-_bab_parent:true")) {
        elementFound = true;
        clearInterval(intervalId);

        const classString = item.classList.toString();
        const classes = classString.split(" ");

        // Find the class that contains "property-_total_price"
        const totalPriceClass = classes.find((className) =>
          className.startsWith("property-_total_price:")
        );

        // Extract the value associated with the property-_total_price class
        if (totalPriceClass) {
          const value = totalPriceClass.split(":")[1];
          const priceEl = item.querySelector(
            ".rebuy-cart__flyout-item-price .rebuy-money span:nth-child(2)"
          );
          priceEl.innerHTML = `£${(parseInt(value) / 100).toFixed(2)}`;
        } else {
          console.log("property-_total_price class not found");
        }
      }
    }

    if (elementFound || timeElapsed >= maxTime) {
      clearInterval(intervalId);
    }

    timeElapsed += 100; // Increment timeElapsed by the interval (100 milliseconds)
  }, 100); // Check every 100 milliseconds
}

document.addEventListener("rebuy:smartcart.ready", (event) => {
  //const smartcart = event.detail.smartcart;
  updateRebuyBundlePrices();
});

document.addEventListener("rebuy:cart.change", (event) => {
  updateRebuyBundlePrices();
});

document.addEventListener("rebuy:cart.add", (event) => {
  setTimeout(() => {
    updateRebuyBundlePrices();
  }, 1000);
});
